/* tslint:disable */
/* eslint-disable */
/**
 * FanFair Complete API
 * Complete API documentation for FanFair platform including both public and private endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetTransactionsSince200Response } from '../models';
// @ts-ignore
import type { MerchantBalanceResponse } from '../models';
// @ts-ignore
import type { PaginatedSummaryMerchantTransaction } from '../models';
// @ts-ignore
import type { RefundEligibilityResponse } from '../models';
// @ts-ignore
import type { RefundTransactionRequest } from '../models';
// @ts-ignore
import type { RefundTransactionResponse } from '../models';
// @ts-ignore
import type { SearchTransactions200Response } from '../models';
// @ts-ignore
import type { TransactionBatchRequest } from '../models';
// @ts-ignore
import type { TransactionBatchResponse } from '../models';
// @ts-ignore
import type { TransactionDetail } from '../models';
// @ts-ignore
import type { VoidTransactionRequest } from '../models';
// @ts-ignore
import type { VoidTransactionResponse } from '../models';
/**
 * PaymentReportingApi - axios parameter creator
 * @export
 */
export const PaymentReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Checks whether a transaction is eligible for refund based on business rules.  Eligibility Rules: 1. Transaction must be at least 24 hours old (configurable) 2. No COMPLETED void exists for this transaction 3. Transaction must be no more than 180 days old (configurable) 4. No IN_PROGRESS refund exists for this transaction 5. Remaining refundable amount must be > 0 (based on the original cardholder-paid amount, minus total previously refunded)  Note: All validation failures are returned together (non-fail-fast). 
         * @summary Check refund eligibility for a transaction
         * @param {string} transactionId UUID of the transaction to check refund eligibility for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRefundEligibility: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('checkRefundEligibility', 'transactionId', transactionId)
            const localVarPath = `/api/v1/payment-reporting/transactions/{transactionId}/refund-eligibility`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the current balance for a merchant, optionally filtered by currency.
         * @summary Get merchant balance (with optional currency filter)
         * @param {string} merchantId Merchant identifier
         * @param {string} [currency] ISO 4217 currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantBalance: async (merchantId: string, currency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantBalance', 'merchantId', merchantId)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/balances`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve transactions for a merchant filtered by currency, returned in descending date order.
         * @summary Get merchant transaction, filtered by currency, in descending date order.
         * @param {string} merchantId Merchant identifier
         * @param {string} currency ISO 4217 currency code
         * @param {string} [startDate] Inclusive start date (ISO 8601)
         * @param {string} [endDate] Inclusive end date (ISO 8601)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantTransactions: async (merchantId: string, currency: string, startDate?: string, endDate?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantId' is not null or undefined
            assertParamExists('getMerchantTransactions', 'merchantId', merchantId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('getMerchantTransactions', 'currency', currency)
            const localVarPath = `/api/v1/payment-reporting/merchants/{merchantId}/transactions/{currency}`
                .replace(`{${"merchantId"}}`, encodeURIComponent(String(merchantId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves comprehensive details for a specific transaction.  Includes fee breakdown, settlement information, and audit trail. 
         * @summary Get detailed transaction information with role-based access
         * @param {string} transactionId Transaction UUID identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetail: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('getTransactionDetail', 'transactionId', transactionId)
            const localVarPath = `/api/v1/payment-reporting/transactions/{transactionId}`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all transactions created after the specified transaction ID. Used by the main platform to detect new transactions for payment session updates.  RESTRICTED ACCESS: Only Service API Keys with appropriate scopes can access this endpoint. Scope restrictions are enforced based on the service identity in the JWT. 
         * @summary Get new transactions since specified ID (Service API Key only)
         * @param {number} lastTransactionId Last processed transaction ID (0 for initial query)
         * @param {number} [limit] Maximum number of transactions to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsSince: async (lastTransactionId: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lastTransactionId' is not null or undefined
            assertParamExists('getTransactionsSince', 'lastTransactionId', lastTransactionId)
            const localVarPath = `/api/v1/payment-reporting/transactions/since/{lastTransactionId}`
                .replace(`{${"lastTransactionId"}}`, encodeURIComponent(String(lastTransactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ServiceBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes a full or partial refund for a completed transaction. The refund cap is the original cardholder-paid amount (totalAmount). Partner and FanFair fees are not refunded — those balances are unaffected by a refund. The merchant ledger may go negative if the refund exceeds the merchant\'s net share.  When no `amount` is provided (or null), a full refund of the remaining refundable amount is processed. When `amount` is provided, a partial refund is processed for that amount. Multiple partial refunds are allowed until the full refundable amount has been refunded. 
         * @summary Process a refund for a completed transaction
         * @param {string} transactionId UUID of the transaction to refund
         * @param {string} idempotencyKey Unique key for idempotent request handling. If a refund request with this key was already processed, the original result will be returned instead of creating a new refund. 
         * @param {RefundTransactionRequest} refundTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRefund: async (transactionId: string, idempotencyKey: string, refundTransactionRequest: RefundTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('processRefund', 'transactionId', transactionId)
            // verify required parameter 'idempotencyKey' is not null or undefined
            assertParamExists('processRefund', 'idempotencyKey', idempotencyKey)
            // verify required parameter 'refundTransactionRequest' is not null or undefined
            assertParamExists('processRefund', 'refundTransactionRequest', refundTransactionRequest)
            const localVarPath = `/api/v1/payment-reporting/transactions/{transactionId}/refunds`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (idempotencyKey != null) {
                localVarHeaderParameter['Idempotency-Key'] = String(idempotencyKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refundTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves transactions Supports filtering, pagination, and sorting for efficient data access. 
         * @summary Search transactions
         * @param {string} [partnerId] Filter by partner ID 
         * @param {string} [merchantId] Filter by specific merchant ID
         * @param {SearchTransactionsTransactionTypeEnum} [transactionType] Filter by transaction type
         * @param {SearchTransactionsPaymentMethodTypeEnum} [paymentMethodType] Filter by payment method type
         * @param {string} [startDate] Start date filter (ISO 8601)
         * @param {string} [endDate] End date filter (ISO 8601)
         * @param {string} [customerEmail] Filter by customer email (exact match)
         * @param {string} [sessionId] Filter by payment session ID
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {SearchTransactionsSortEnum} [sort] Sort order (- prefix for descending)
         * @param {string} [merchantName] Filter by merchant name (partial match, minimum 2 characters)
         * @param {string} [customerName] Filter by customer name (partial match, minimum 2 characters)
         * @param {string} [cardLastFour] Filter by last 4 digits of card number (exact match)
         * @param {string} [transactionId] Filter by transaction ID (exact UUID match)
         * @param {number} [minAmount] Minimum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {number} [maxAmount] Maximum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {string} [merchantReference] Filter by merchant reference/descriptor (partial match, case-insensitive, minimum 2 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactions: async (partnerId?: string, merchantId?: string, transactionType?: SearchTransactionsTransactionTypeEnum, paymentMethodType?: SearchTransactionsPaymentMethodTypeEnum, startDate?: string, endDate?: string, customerEmail?: string, sessionId?: string, page?: number, size?: number, sort?: SearchTransactionsSortEnum, merchantName?: string, customerName?: string, cardLastFour?: string, transactionId?: string, minAmount?: number, maxAmount?: number, merchantReference?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/payment-reporting/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }

            if (merchantId !== undefined) {
                localVarQueryParameter['merchantId'] = merchantId;
            }

            if (transactionType !== undefined) {
                localVarQueryParameter['transactionType'] = transactionType;
            }

            if (paymentMethodType !== undefined) {
                localVarQueryParameter['paymentMethodType'] = paymentMethodType;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString().substring(0,10) :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString().substring(0,10) :
                    endDate;
            }

            if (customerEmail !== undefined) {
                localVarQueryParameter['customerEmail'] = customerEmail;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['sessionId'] = sessionId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (merchantName !== undefined) {
                localVarQueryParameter['merchantName'] = merchantName;
            }

            if (customerName !== undefined) {
                localVarQueryParameter['customerName'] = customerName;
            }

            if (cardLastFour !== undefined) {
                localVarQueryParameter['cardLastFour'] = cardLastFour;
            }

            if (transactionId !== undefined) {
                localVarQueryParameter['transactionId'] = transactionId;
            }

            if (minAmount !== undefined) {
                localVarQueryParameter['minAmount'] = minAmount;
            }

            if (maxAmount !== undefined) {
                localVarQueryParameter['maxAmount'] = maxAmount;
            }

            if (merchantReference !== undefined) {
                localVarQueryParameter['merchantReference'] = merchantReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Uploads transactions for payment session processing. Accepts batches of transaction summaries and validates them according to business rules. 
         * @summary Upload transactions
         * @param {TransactionBatchRequest} transactionBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransactions: async (transactionBatchRequest: TransactionBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionBatchRequest' is not null or undefined
            assertParamExists('uploadTransactions', 'transactionBatchRequest', transactionBatchRequest)
            const localVarPath = `/api/v1/payment-reporting/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transactionBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates a void operation for a completed transaction. This creates an inverse transaction with a negative amount to offset the original transaction.  The void process: 1. Validates transaction eligibility (must be same-day, COMPLETED status) 2. Creates a void_requested record for tracking 3. Calls the payment processor to reverse the transaction 4. Creates an inverse transaction with negative amounts 5. Updates the void_requested status to COMPLETED or FAILED  Access is controlled by partner ownership - only the partner who owns the transaction can void it. 
         * @summary Void a completed transaction
         * @param {string} transactionId UUID of the transaction to void
         * @param {VoidTransactionRequest} voidTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidTransaction: async (transactionId: string, voidTransactionRequest: VoidTransactionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('voidTransaction', 'transactionId', transactionId)
            // verify required parameter 'voidTransactionRequest' is not null or undefined
            assertParamExists('voidTransaction', 'voidTransactionRequest', voidTransactionRequest)
            const localVarPath = `/api/v1/payment-reporting/transactions/{transactionId}/voids`
                .replace(`{${"transactionId"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication UserBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voidTransactionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentReportingApi - functional programming interface
 * @export
 */
export const PaymentReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * Checks whether a transaction is eligible for refund based on business rules.  Eligibility Rules: 1. Transaction must be at least 24 hours old (configurable) 2. No COMPLETED void exists for this transaction 3. Transaction must be no more than 180 days old (configurable) 4. No IN_PROGRESS refund exists for this transaction 5. Remaining refundable amount must be > 0 (based on the original cardholder-paid amount, minus total previously refunded)  Note: All validation failures are returned together (non-fail-fast). 
         * @summary Check refund eligibility for a transaction
         * @param {string} transactionId UUID of the transaction to check refund eligibility for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkRefundEligibility(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundEligibilityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkRefundEligibility(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.checkRefundEligibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the current balance for a merchant, optionally filtered by currency.
         * @summary Get merchant balance (with optional currency filter)
         * @param {string} merchantId Merchant identifier
         * @param {string} [currency] ISO 4217 currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantBalance(merchantId: string, currency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantBalanceResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantBalance(merchantId, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.getMerchantBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve transactions for a merchant filtered by currency, returned in descending date order.
         * @summary Get merchant transaction, filtered by currency, in descending date order.
         * @param {string} merchantId Merchant identifier
         * @param {string} currency ISO 4217 currency code
         * @param {string} [startDate] Inclusive start date (ISO 8601)
         * @param {string} [endDate] Inclusive end date (ISO 8601)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantTransactions(merchantId: string, currency: string, startDate?: string, endDate?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PaginatedSummaryMerchantTransaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantTransactions(merchantId, currency, startDate, endDate, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.getMerchantTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves comprehensive details for a specific transaction.  Includes fee breakdown, settlement information, and audit trail. 
         * @summary Get detailed transaction information with role-based access
         * @param {string} transactionId Transaction UUID identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionDetail(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionDetail(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.getTransactionDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all transactions created after the specified transaction ID. Used by the main platform to detect new transactions for payment session updates.  RESTRICTED ACCESS: Only Service API Keys with appropriate scopes can access this endpoint. Scope restrictions are enforced based on the service identity in the JWT. 
         * @summary Get new transactions since specified ID (Service API Key only)
         * @param {number} lastTransactionId Last processed transaction ID (0 for initial query)
         * @param {number} [limit] Maximum number of transactions to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsSince(lastTransactionId: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTransactionsSince200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsSince(lastTransactionId, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.getTransactionsSince']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes a full or partial refund for a completed transaction. The refund cap is the original cardholder-paid amount (totalAmount). Partner and FanFair fees are not refunded — those balances are unaffected by a refund. The merchant ledger may go negative if the refund exceeds the merchant\'s net share.  When no `amount` is provided (or null), a full refund of the remaining refundable amount is processed. When `amount` is provided, a partial refund is processed for that amount. Multiple partial refunds are allowed until the full refundable amount has been refunded. 
         * @summary Process a refund for a completed transaction
         * @param {string} transactionId UUID of the transaction to refund
         * @param {string} idempotencyKey Unique key for idempotent request handling. If a refund request with this key was already processed, the original result will be returned instead of creating a new refund. 
         * @param {RefundTransactionRequest} refundTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processRefund(transactionId: string, idempotencyKey: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RefundTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processRefund(transactionId, idempotencyKey, refundTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.processRefund']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves transactions Supports filtering, pagination, and sorting for efficient data access. 
         * @summary Search transactions
         * @param {string} [partnerId] Filter by partner ID 
         * @param {string} [merchantId] Filter by specific merchant ID
         * @param {SearchTransactionsTransactionTypeEnum} [transactionType] Filter by transaction type
         * @param {SearchTransactionsPaymentMethodTypeEnum} [paymentMethodType] Filter by payment method type
         * @param {string} [startDate] Start date filter (ISO 8601)
         * @param {string} [endDate] End date filter (ISO 8601)
         * @param {string} [customerEmail] Filter by customer email (exact match)
         * @param {string} [sessionId] Filter by payment session ID
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {SearchTransactionsSortEnum} [sort] Sort order (- prefix for descending)
         * @param {string} [merchantName] Filter by merchant name (partial match, minimum 2 characters)
         * @param {string} [customerName] Filter by customer name (partial match, minimum 2 characters)
         * @param {string} [cardLastFour] Filter by last 4 digits of card number (exact match)
         * @param {string} [transactionId] Filter by transaction ID (exact UUID match)
         * @param {number} [minAmount] Minimum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {number} [maxAmount] Maximum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {string} [merchantReference] Filter by merchant reference/descriptor (partial match, case-insensitive, minimum 2 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTransactions(partnerId?: string, merchantId?: string, transactionType?: SearchTransactionsTransactionTypeEnum, paymentMethodType?: SearchTransactionsPaymentMethodTypeEnum, startDate?: string, endDate?: string, customerEmail?: string, sessionId?: string, page?: number, size?: number, sort?: SearchTransactionsSortEnum, merchantName?: string, customerName?: string, cardLastFour?: string, transactionId?: string, minAmount?: number, maxAmount?: number, merchantReference?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchTransactions200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTransactions(partnerId, merchantId, transactionType, paymentMethodType, startDate, endDate, customerEmail, sessionId, page, size, sort, merchantName, customerName, cardLastFour, transactionId, minAmount, maxAmount, merchantReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.searchTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Uploads transactions for payment session processing. Accepts batches of transaction summaries and validates them according to business rules. 
         * @summary Upload transactions
         * @param {TransactionBatchRequest} transactionBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadTransactions(transactionBatchRequest: TransactionBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionBatchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadTransactions(transactionBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.uploadTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates a void operation for a completed transaction. This creates an inverse transaction with a negative amount to offset the original transaction.  The void process: 1. Validates transaction eligibility (must be same-day, COMPLETED status) 2. Creates a void_requested record for tracking 3. Calls the payment processor to reverse the transaction 4. Creates an inverse transaction with negative amounts 5. Updates the void_requested status to COMPLETED or FAILED  Access is controlled by partner ownership - only the partner who owns the transaction can void it. 
         * @summary Void a completed transaction
         * @param {string} transactionId UUID of the transaction to void
         * @param {VoidTransactionRequest} voidTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async voidTransaction(transactionId: string, voidTransactionRequest: VoidTransactionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VoidTransactionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.voidTransaction(transactionId, voidTransactionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PaymentReportingApi.voidTransaction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PaymentReportingApi - factory interface
 * @export
 */
export const PaymentReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentReportingApiFp(configuration)
    return {
        /**
         * Checks whether a transaction is eligible for refund based on business rules.  Eligibility Rules: 1. Transaction must be at least 24 hours old (configurable) 2. No COMPLETED void exists for this transaction 3. Transaction must be no more than 180 days old (configurable) 4. No IN_PROGRESS refund exists for this transaction 5. Remaining refundable amount must be > 0 (based on the original cardholder-paid amount, minus total previously refunded)  Note: All validation failures are returned together (non-fail-fast). 
         * @summary Check refund eligibility for a transaction
         * @param {string} transactionId UUID of the transaction to check refund eligibility for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkRefundEligibility(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<RefundEligibilityResponse> {
            return localVarFp.checkRefundEligibility(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the current balance for a merchant, optionally filtered by currency.
         * @summary Get merchant balance (with optional currency filter)
         * @param {string} merchantId Merchant identifier
         * @param {string} [currency] ISO 4217 currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantBalance(merchantId: string, currency?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<MerchantBalanceResponse>> {
            return localVarFp.getMerchantBalance(merchantId, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve transactions for a merchant filtered by currency, returned in descending date order.
         * @summary Get merchant transaction, filtered by currency, in descending date order.
         * @param {string} merchantId Merchant identifier
         * @param {string} currency ISO 4217 currency code
         * @param {string} [startDate] Inclusive start date (ISO 8601)
         * @param {string} [endDate] Inclusive end date (ISO 8601)
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantTransactions(merchantId: string, currency: string, startDate?: string, endDate?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<PaginatedSummaryMerchantTransaction>> {
            return localVarFp.getMerchantTransactions(merchantId, currency, startDate, endDate, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves comprehensive details for a specific transaction.  Includes fee breakdown, settlement information, and audit trail. 
         * @summary Get detailed transaction information with role-based access
         * @param {string} transactionId Transaction UUID identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionDetail(transactionId: string, options?: RawAxiosRequestConfig): AxiosPromise<TransactionDetail> {
            return localVarFp.getTransactionDetail(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all transactions created after the specified transaction ID. Used by the main platform to detect new transactions for payment session updates.  RESTRICTED ACCESS: Only Service API Keys with appropriate scopes can access this endpoint. Scope restrictions are enforced based on the service identity in the JWT. 
         * @summary Get new transactions since specified ID (Service API Key only)
         * @param {number} lastTransactionId Last processed transaction ID (0 for initial query)
         * @param {number} [limit] Maximum number of transactions to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsSince(lastTransactionId: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetTransactionsSince200Response> {
            return localVarFp.getTransactionsSince(lastTransactionId, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes a full or partial refund for a completed transaction. The refund cap is the original cardholder-paid amount (totalAmount). Partner and FanFair fees are not refunded — those balances are unaffected by a refund. The merchant ledger may go negative if the refund exceeds the merchant\'s net share.  When no `amount` is provided (or null), a full refund of the remaining refundable amount is processed. When `amount` is provided, a partial refund is processed for that amount. Multiple partial refunds are allowed until the full refundable amount has been refunded. 
         * @summary Process a refund for a completed transaction
         * @param {string} transactionId UUID of the transaction to refund
         * @param {string} idempotencyKey Unique key for idempotent request handling. If a refund request with this key was already processed, the original result will be returned instead of creating a new refund. 
         * @param {RefundTransactionRequest} refundTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processRefund(transactionId: string, idempotencyKey: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<RefundTransactionResponse> {
            return localVarFp.processRefund(transactionId, idempotencyKey, refundTransactionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves transactions Supports filtering, pagination, and sorting for efficient data access. 
         * @summary Search transactions
         * @param {string} [partnerId] Filter by partner ID 
         * @param {string} [merchantId] Filter by specific merchant ID
         * @param {SearchTransactionsTransactionTypeEnum} [transactionType] Filter by transaction type
         * @param {SearchTransactionsPaymentMethodTypeEnum} [paymentMethodType] Filter by payment method type
         * @param {string} [startDate] Start date filter (ISO 8601)
         * @param {string} [endDate] End date filter (ISO 8601)
         * @param {string} [customerEmail] Filter by customer email (exact match)
         * @param {string} [sessionId] Filter by payment session ID
         * @param {number} [page] The zero-based index of the page of results to return.
         * @param {number} [size] The maximum number of results to return in a page.
         * @param {SearchTransactionsSortEnum} [sort] Sort order (- prefix for descending)
         * @param {string} [merchantName] Filter by merchant name (partial match, minimum 2 characters)
         * @param {string} [customerName] Filter by customer name (partial match, minimum 2 characters)
         * @param {string} [cardLastFour] Filter by last 4 digits of card number (exact match)
         * @param {string} [transactionId] Filter by transaction ID (exact UUID match)
         * @param {number} [minAmount] Minimum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {number} [maxAmount] Maximum transaction amount in cents (inclusive). Can be negative for voids/refunds.
         * @param {string} [merchantReference] Filter by merchant reference/descriptor (partial match, case-insensitive, minimum 2 characters)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTransactions(partnerId?: string, merchantId?: string, transactionType?: SearchTransactionsTransactionTypeEnum, paymentMethodType?: SearchTransactionsPaymentMethodTypeEnum, startDate?: string, endDate?: string, customerEmail?: string, sessionId?: string, page?: number, size?: number, sort?: SearchTransactionsSortEnum, merchantName?: string, customerName?: string, cardLastFour?: string, transactionId?: string, minAmount?: number, maxAmount?: number, merchantReference?: string, options?: RawAxiosRequestConfig): AxiosPromise<SearchTransactions200Response> {
            return localVarFp.searchTransactions(partnerId, merchantId, transactionType, paymentMethodType, startDate, endDate, customerEmail, sessionId, page, size, sort, merchantName, customerName, cardLastFour, transactionId, minAmount, maxAmount, merchantReference, options).then((request) => request(axios, basePath));
        },
        /**
         * Uploads transactions for payment session processing. Accepts batches of transaction summaries and validates them according to business rules. 
         * @summary Upload transactions
         * @param {TransactionBatchRequest} transactionBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadTransactions(transactionBatchRequest: TransactionBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransactionBatchResponse> {
            return localVarFp.uploadTransactions(transactionBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates a void operation for a completed transaction. This creates an inverse transaction with a negative amount to offset the original transaction.  The void process: 1. Validates transaction eligibility (must be same-day, COMPLETED status) 2. Creates a void_requested record for tracking 3. Calls the payment processor to reverse the transaction 4. Creates an inverse transaction with negative amounts 5. Updates the void_requested status to COMPLETED or FAILED  Access is controlled by partner ownership - only the partner who owns the transaction can void it. 
         * @summary Void a completed transaction
         * @param {string} transactionId UUID of the transaction to void
         * @param {VoidTransactionRequest} voidTransactionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        voidTransaction(transactionId: string, voidTransactionRequest: VoidTransactionRequest, options?: RawAxiosRequestConfig): AxiosPromise<VoidTransactionResponse> {
            return localVarFp.voidTransaction(transactionId, voidTransactionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentReportingApi - object-oriented interface
 * @export
 * @class PaymentReportingApi
 * @extends {BaseAPI}
 */
export class PaymentReportingApi extends BaseAPI {
    /**
     * Checks whether a transaction is eligible for refund based on business rules.  Eligibility Rules: 1. Transaction must be at least 24 hours old (configurable) 2. No COMPLETED void exists for this transaction 3. Transaction must be no more than 180 days old (configurable) 4. No IN_PROGRESS refund exists for this transaction 5. Remaining refundable amount must be > 0 (based on the original cardholder-paid amount, minus total previously refunded)  Note: All validation failures are returned together (non-fail-fast). 
     * @summary Check refund eligibility for a transaction
     * @param {string} transactionId UUID of the transaction to check refund eligibility for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public checkRefundEligibility(transactionId: string, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).checkRefundEligibility(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the current balance for a merchant, optionally filtered by currency.
     * @summary Get merchant balance (with optional currency filter)
     * @param {string} merchantId Merchant identifier
     * @param {string} [currency] ISO 4217 currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public getMerchantBalance(merchantId: string, currency?: string, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).getMerchantBalance(merchantId, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve transactions for a merchant filtered by currency, returned in descending date order.
     * @summary Get merchant transaction, filtered by currency, in descending date order.
     * @param {string} merchantId Merchant identifier
     * @param {string} currency ISO 4217 currency code
     * @param {string} [startDate] Inclusive start date (ISO 8601)
     * @param {string} [endDate] Inclusive end date (ISO 8601)
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public getMerchantTransactions(merchantId: string, currency: string, startDate?: string, endDate?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).getMerchantTransactions(merchantId, currency, startDate, endDate, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves comprehensive details for a specific transaction.  Includes fee breakdown, settlement information, and audit trail. 
     * @summary Get detailed transaction information with role-based access
     * @param {string} transactionId Transaction UUID identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public getTransactionDetail(transactionId: string, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).getTransactionDetail(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all transactions created after the specified transaction ID. Used by the main platform to detect new transactions for payment session updates.  RESTRICTED ACCESS: Only Service API Keys with appropriate scopes can access this endpoint. Scope restrictions are enforced based on the service identity in the JWT. 
     * @summary Get new transactions since specified ID (Service API Key only)
     * @param {number} lastTransactionId Last processed transaction ID (0 for initial query)
     * @param {number} [limit] Maximum number of transactions to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public getTransactionsSince(lastTransactionId: number, limit?: number, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).getTransactionsSince(lastTransactionId, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes a full or partial refund for a completed transaction. The refund cap is the original cardholder-paid amount (totalAmount). Partner and FanFair fees are not refunded — those balances are unaffected by a refund. The merchant ledger may go negative if the refund exceeds the merchant\'s net share.  When no `amount` is provided (or null), a full refund of the remaining refundable amount is processed. When `amount` is provided, a partial refund is processed for that amount. Multiple partial refunds are allowed until the full refundable amount has been refunded. 
     * @summary Process a refund for a completed transaction
     * @param {string} transactionId UUID of the transaction to refund
     * @param {string} idempotencyKey Unique key for idempotent request handling. If a refund request with this key was already processed, the original result will be returned instead of creating a new refund. 
     * @param {RefundTransactionRequest} refundTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public processRefund(transactionId: string, idempotencyKey: string, refundTransactionRequest: RefundTransactionRequest, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).processRefund(transactionId, idempotencyKey, refundTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves transactions Supports filtering, pagination, and sorting for efficient data access. 
     * @summary Search transactions
     * @param {string} [partnerId] Filter by partner ID 
     * @param {string} [merchantId] Filter by specific merchant ID
     * @param {SearchTransactionsTransactionTypeEnum} [transactionType] Filter by transaction type
     * @param {SearchTransactionsPaymentMethodTypeEnum} [paymentMethodType] Filter by payment method type
     * @param {string} [startDate] Start date filter (ISO 8601)
     * @param {string} [endDate] End date filter (ISO 8601)
     * @param {string} [customerEmail] Filter by customer email (exact match)
     * @param {string} [sessionId] Filter by payment session ID
     * @param {number} [page] The zero-based index of the page of results to return.
     * @param {number} [size] The maximum number of results to return in a page.
     * @param {SearchTransactionsSortEnum} [sort] Sort order (- prefix for descending)
     * @param {string} [merchantName] Filter by merchant name (partial match, minimum 2 characters)
     * @param {string} [customerName] Filter by customer name (partial match, minimum 2 characters)
     * @param {string} [cardLastFour] Filter by last 4 digits of card number (exact match)
     * @param {string} [transactionId] Filter by transaction ID (exact UUID match)
     * @param {number} [minAmount] Minimum transaction amount in cents (inclusive). Can be negative for voids/refunds.
     * @param {number} [maxAmount] Maximum transaction amount in cents (inclusive). Can be negative for voids/refunds.
     * @param {string} [merchantReference] Filter by merchant reference/descriptor (partial match, case-insensitive, minimum 2 characters)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public searchTransactions(partnerId?: string, merchantId?: string, transactionType?: SearchTransactionsTransactionTypeEnum, paymentMethodType?: SearchTransactionsPaymentMethodTypeEnum, startDate?: string, endDate?: string, customerEmail?: string, sessionId?: string, page?: number, size?: number, sort?: SearchTransactionsSortEnum, merchantName?: string, customerName?: string, cardLastFour?: string, transactionId?: string, minAmount?: number, maxAmount?: number, merchantReference?: string, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).searchTransactions(partnerId, merchantId, transactionType, paymentMethodType, startDate, endDate, customerEmail, sessionId, page, size, sort, merchantName, customerName, cardLastFour, transactionId, minAmount, maxAmount, merchantReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Uploads transactions for payment session processing. Accepts batches of transaction summaries and validates them according to business rules. 
     * @summary Upload transactions
     * @param {TransactionBatchRequest} transactionBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public uploadTransactions(transactionBatchRequest: TransactionBatchRequest, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).uploadTransactions(transactionBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates a void operation for a completed transaction. This creates an inverse transaction with a negative amount to offset the original transaction.  The void process: 1. Validates transaction eligibility (must be same-day, COMPLETED status) 2. Creates a void_requested record for tracking 3. Calls the payment processor to reverse the transaction 4. Creates an inverse transaction with negative amounts 5. Updates the void_requested status to COMPLETED or FAILED  Access is controlled by partner ownership - only the partner who owns the transaction can void it. 
     * @summary Void a completed transaction
     * @param {string} transactionId UUID of the transaction to void
     * @param {VoidTransactionRequest} voidTransactionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentReportingApi
     */
    public voidTransaction(transactionId: string, voidTransactionRequest: VoidTransactionRequest, options?: RawAxiosRequestConfig) {
        return PaymentReportingApiFp(this.configuration).voidTransaction(transactionId, voidTransactionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SearchTransactionsTransactionTypeEnum = {
    Payment: 'PAYMENT',
    Refund: 'REFUND',
    Void: 'VOID',
    Chargeback: 'CHARGEBACK'
} as const;
export type SearchTransactionsTransactionTypeEnum = typeof SearchTransactionsTransactionTypeEnum[keyof typeof SearchTransactionsTransactionTypeEnum];
/**
 * @export
 */
export const SearchTransactionsPaymentMethodTypeEnum = {
    Card: 'CARD',
    Ach: 'ACH',
    ApplePay: 'APPLE_PAY',
    GooglePay: 'GOOGLE_PAY',
    DigitalWallet: 'DIGITAL_WALLET'
} as const;
export type SearchTransactionsPaymentMethodTypeEnum = typeof SearchTransactionsPaymentMethodTypeEnum[keyof typeof SearchTransactionsPaymentMethodTypeEnum];
/**
 * @export
 */
export const SearchTransactionsSortEnum = {
    MerchantName: 'merchantName',
    CustomerName: 'customerName',
    MerchantReference: 'merchantReference',
    Amount: 'amount',
    TransactionType: 'transactionType',
    CreatedAt: 'createdAt'
} as const;
export type SearchTransactionsSortEnum = typeof SearchTransactionsSortEnum[keyof typeof SearchTransactionsSortEnum];
